import React from 'react';
import styles from './index.module.less';
import { getOfficialSitePath } from '@/utils/function/sitePath';
import { HeaderContext } from '../../common';
const CompHeaderLogo: React.FC = () => {
    const { getTextByKey } = React.useContext(HeaderContext);
    return (
        <a
            href={ getOfficialSitePath() }
            className={ styles['header-logo-link'] }
            title={ getTextByKey('brand-slogan') }>
            <img
                src="https://home-cdn.reolink.us/wp-content/assets/header-svg-white.svg"
                alt="logo" />
        </a>
    );
};

export default CompHeaderLogo;
